export class LabeledListItem {
    constructor(
        public readonly label: string,
        public readonly value: string | string[],
        public readonly clickEventName?: string
    ) {}
}
